import { createOptimizerWorkerClient as m } from "./createOptimizerWorkerClient.js";
async function c(s, r, l) {
  const { worker: o, api: e } = l ?? m();
  r ? await r() : await e.warmup(), await e.init(s.options, s.excelPath);
  const d = await e.getInitialSnapshot();
  return {
    worker: o,
    service: {
      ...d,
      diminishing: await e.diminishing(),
      refineSpend: (t) => e.refineSpend(t),
      createOptimisedPlans: (t, i, a, n, g) => e.createOptimisedPlans(
        t,
        i ? i.toString() : void 0,
        a ? a.toString() : void 0,
        n,
        g
      ),
      getKPILimits: (t, i, a) => e.getKPILimits(t, i, a),
      getBudgetLimits: (t, i) => e.getBudgetLimits(t, i),
      getTotalKPILimits: (t, i, a) => e.getTotalKPILimits(t, i, a),
      getNonMediaKpi: () => e.getNonMediaKpi(),
      getMediasLimits: () => e.getMediasLimits(),
      getActiveDaysPerMedium: () => e.getActiveDaysPerMedium(),
      updateRules: (t) => e.updateRules(t),
      resetOptimisationRules: () => e.resetRules(),
      readMessages: () => e.readMessages(),
      getNaturalDemandData: () => e.getNaturalDemandData(),
      getRoiCurvesData: () => e.getRoiCurvesData(),
      getOptimizerVersion: () => e.getOptimizerVersion(),
      setAllowedWeekdays: (t, i) => e.setAllowedWeekdays(t, i),
      getAllowedWeekdays: (t) => e.getAllowedWeekdays(t),
      getAllAllowedWeekdays: () => e.getAllAllowedWeekdays(),
      clearDailyPlanCache: () => e.clearDailyPlanCache(),
      replayFromJsonl: (t) => e.replayFromJsonl(t)
    }
  };
}
export {
  c as createWorkerOptimizerPort
};
